/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/sections/opk-chat.js":
/*!******************************************!*\
  !*** ./src/scripts/sections/opk-chat.js ***!
  \******************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_sections_opk_chat_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../styles/sections/opk-chat.scss */ \"./src/styles/sections/opk-chat.scss\");\n\nconst applyWidgetToggler = () => {\n  const openButtons = document.querySelectorAll('[data-floating-button]');\n  const closeButton = document.getElementById('widget-button');\n  const widget = document.getElementById('floating-widget');\n  for (const openButton of openButtons) {\n    openButton.addEventListener('click', () => {\n      for (const btn of openButtons) {\n        btn.classList.remove('floating-buttons__button--visible');\n        setTimeout(() => {\n          btn.classList.remove('floating-buttons__button--active');\n        }, 330);\n      }\n      setTimeout(() => {\n        widget.classList.add('opk-widget--active');\n        setTimeout(() => {\n          widget.classList.add('opk-widget--visible');\n        }, 10);\n      }, 330);\n    });\n  }\n  closeButton.addEventListener('click', () => {\n    widget.classList.remove('opk-widget--visible');\n    setTimeout(() => {\n      widget.classList.remove('opk-widget--active');\n    }, 330);\n    setTimeout(() => {\n      for (const openButton of openButtons) {\n        openButton.classList.add('floating-buttons__button--active');\n        setTimeout(() => {\n          openButton.classList.add('floating-buttons__button--visible');\n        }, 350);\n      }\n    }, 330);\n  });\n};\napplyWidgetToggler();\n\n//# sourceURL=webpack://la-luna-bags/./src/scripts/sections/opk-chat.js?");

/***/ }),

/***/ "./src/styles/sections/opk-chat.scss":
/*!*******************************************!*\
  !*** ./src/styles/sections/opk-chat.scss ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://la-luna-bags/./src/styles/sections/opk-chat.scss?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/sections/opk-chat.js");
/******/ 	
/******/ })()
;